import axios from 'axios'
import _ from 'lodash'
import * as Sentry from '@sentry/browser'

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (err) => {
    Sentry.captureException(err)
    const status = _.get(err, 'response.status') || err.status

    if (status !== 200) {
      switch (status) {
        case 401:
          console.error('401 - Solicitação não autorizada.')
          break
        default:
          break
      }
    }

    return Promise.reject(err)
  },
)

export default axios 
